import React from 'react';
import Media from "react-media";
import RenderChildren from './renderChildren';

export const mediaQueriesList = {
  xxs: { name: 'xxs', query: "(max-width: 439.98px)", size: 1 },
  xs: { name: 'xs', query: "(min-width: 440px) and (max-width: 575.98px)", size: 2 },
  sm: { name: 'sm', query: "(min-width: 576px) and (max-width: 767.98px)", size: 3 },
  md: { name: 'md', query: "(min-width: 768px) and (max-width: 991.98px)", size: 4 },
  lg: { name: 'lg', query: "(min-width: 992px) and (max-width: 1199.98px)", size: 5 },
  xl: { name: 'xl', query: "(min-width: 1200px) and (max-width: 1799.98px)", size: 6 },
  xxl: { name: 'xxl', query: "(min-width: 1800px)", size: 7 }
};

const withMediaQueries = (WrappedComponent) => {
  return class extends React.Component {
    mediaQueries = mediaQueriesList;
    screenLargerThan = (screenSize) => (other) => {
      return typeof other === 'string'
        ? this.mediaQueries[screenSize].size > this.mediaQueries[other].size
        : this.mediaQueries[screenSize].size > other.size;
    };

    render = () => {
      const renderedQueries = Object.entries(this.mediaQueries)
        .map(([key, value]) => (
          <Media
            query={value.query}
            id={key}
            key={key}
            render={() => (
              <WrappedComponent
                screenSize={value.name}
                screenSizeUtils={{
                  mediaQueriesList: this.mediaQueries,
                  screenLargerThan: this.screenLargerThan(value.name)
                }}
                {...this.props}
              />)}
          />));

      return (<RenderChildren>{renderedQueries}</RenderChildren>);
    }
  };
};

export default withMediaQueries;
